import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, rupiah } from "@/lib/api";
import { todayWIB } from "@/components/staff/attendance/utils";

const sel = "px-3 py-2 rounded-lg border border-sage-200 bg-paper text-sm";
const dt = (s) => new Date(s).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export const fmtDiff = (v) => `${v > 0 ? "+" : ""}${rupiah(v).replace("Rp-", "-Rp")}`;

const Diff = ({ v, testid }) => {
  if (v == null) return <span className="text-muted2" data-testid={testid}>–</span>;
  const c = v === 0 ? "text-emerald-700" : v < 0 ? "text-red-600" : "text-amber-600";
  return <span className={`font-semibold ${c}`} data-testid={testid}>{fmtDiff(v)}</span>;
};

const Summary = ({ s }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mt-5">
    {[["Tutup kasir", s.closings, "closing-sum-count"], ["Transaksi", s.transactions, "closing-sum-trx"], ["Total sistem", rupiah(s.total_qris), "closing-sum-system"],
      ["QRIS masuk", rupiah(s.actual_qris), "closing-sum-actual"]].map(([l, v, id]) => (
      <div key={l} className="card-paper p-4"><div className="text-xs text-muted2">{l}</div><div className="font-bold text-lg text-forest" data-testid={id}>{v}</div></div>
    ))}
    <div className="card-paper p-4"><div className="text-xs text-muted2">Selisih ({s.mismatch} shift tidak cocok)</div><div className="text-lg"><Diff v={s.difference} testid="closing-sum-diff" /></div></div>
  </div>
);

export const ClosingHistory = ({ outlets: given }) => {
  const [own, setOwn] = useState([]);
  useEffect(() => { if (!given) { api.get("/outlets").then((r) => setOwn(r.data)).catch(() => {}); } }, [given]);
  const outlets = given || own;
  const [month, setMonth] = useState(todayWIB().slice(0, 7));
  const [outlet, setOutlet] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => {
    let live = true;
    api.get("/pos/closings", { params: { month, outlet } }).then((r) => { if (live) setData(r.data); }).catch((e) => toast.error(errMsg(e)));
    return () => { live = false; };
  }, [month, outlet]);

  return (
    <div data-testid="closing-history">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-serif font-semibold text-2xl">Riwayat tutup kasir</h2>
          <p className="text-sm text-muted2">Bandingkan total QRIS sistem dengan uang QRIS yang benar-benar masuk per shift.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className={sel} data-testid="closing-history-month" />
          <select value={outlet} onChange={(e) => setOutlet(e.target.value)} className={sel} data-testid="closing-history-outlet">
            <option value="">Semua gerai</option>
            {outlets.map((o) => <option key={o.code} value={o.code}>{o.code} · {o.name}</option>)}
          </select>
        </div>
      </div>
      {data && <Summary s={data.summary} />}
      {data && data.items.length === 0 && <p className="text-center text-muted2 py-12" data-testid="closing-history-empty">Belum ada tutup kasir di bulan ini.</p>}
      {data?.items.length > 0 && (
        <div className="card-paper mt-5 overflow-x-auto">
          <table className="w-full text-sm" data-testid="closing-history-table">
            <thead><tr className="text-left text-xs text-muted2 border-b border-sage-200">{["Tanggal", "Shift", "Gerai", "Transaksi", "Total sistem", "QRIS masuk", "Selisih", "Ditutup oleh", "Catatan"].map((h) => <th key={h} className="px-4 py-2.5 font-semibold whitespace-nowrap">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-sage-200">
              {data.items.map((c) => {
                const k = `${c.date}-${c.shift}-${c.outlet || "all"}`;
                return (
                  <tr key={k} className={c.difference ? "bg-red-50/60" : ""} data-testid={`closing-row-${k}`}>
                    <td className="px-4 py-2.5 whitespace-nowrap font-semibold">{c.date}</td><td className="px-4 py-2.5">{c.shift_label}</td>
                    <td className="px-4 py-2.5">{c.outlet || "Semua"}</td><td className="px-4 py-2.5">{c.transactions}</td>
                    <td className="px-4 py-2.5 whitespace-nowrap">{rupiah(c.total_qris)}</td>
                    <td className="px-4 py-2.5 whitespace-nowrap">{c.actual_qris == null ? "–" : rupiah(c.actual_qris)}</td>
                    <td className="px-4 py-2.5 whitespace-nowrap"><Diff v={c.difference} testid={`closing-diff-${k}`} /></td>
                    <td className="px-4 py-2.5 whitespace-nowrap">{c.closed_by}<div className="text-xs text-muted2">{dt(c.closed_at)}</div></td>
                    <td className="px-4 py-2.5 text-muted2 max-w-[220px]">{c.note || "–"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
